import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from '../courses/IELTSCourse';
import { gerundsData, getDataForDifficulty } from '../courses/data/grammar/gerunds';

export default function GerundsTips() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : gerundsData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
